<template>
  <div :class="classes">
      <pt-page-title title="广告位管理"></pt-page-title>
      <pt-banner-table :tableLabels="tableLabels">
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="bannerDetail(scope.row)">详情</el-button>
              </template>
          </el-table-column>
      </pt-banner-table>
  </div>
</template>

<script>
import ptBannerTable from './pt-banner-table/withData.vue'
import { bannerListLabels } from './banner-options'
// 组件class前缀
const prefixCls = 'pt-banner-manage'

export default {
  name: 'pt-banner-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptBannerTable
  },
  data () {
    return {
      tableLabels: bannerListLabels
    }
  },
  methods: {
    bannerDetail (val) {
      this.$router.push('/banner-manage/banner-detail/' + val.value + '/' + val.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
